export default "__VITE_ASSET__CmBO_sq9__"